const colors = {
///////////////////////  Legacy Colors  ///////////////////////
// Grayscale
  white: '#ffffff',
  almostWhite: '#f7f7f7',
  lightestGray: '#efefef',
  lighterGray: '#e6e6e6',
  lightGray: '#ccc',
  gray: '#A6A6A6',
  mediumGray: '#8d8d8d',
  darkGray: '#666',
  darkerGray: '#4d4d4d',
  darkestGray: '#333333',
  black: '#000000',
  almostBlack: '#272727',
  charcoalGray: '#3e4142',
// Red
  lighterRed: '#ee6e65',
  red: '#ee5252',
  paleRed: '#f9d3d1',
// Orange
  orange: '#F49C57',
  paleOrange: '#fee8dc',
// Yellow
  yellowOrange: '#f7c870',
  brightYellow: '#ffdd5d',
// Green
  greenYellow: '#71ba6d', // (keypad inputs)
  green: '#0fd599',
// Blue
  paleBlue: '#f1f8fa',
  blue: '#2C9BCE',
  darkGrayBlue: '#31475E',
// Blue Gray
  blueGrayUltralight: '#F7F8FA',
  blueGrayLight3: '#DFE4ED',
  blueGrayLight2: '#99B0C1',
  blueGrayLight1: '#868F97',
  blueGray: '#6B747C',
  blueGrayDark1: '#606972',
  blueGrayDark2: '#48505C',
// Reserved Colors
  colorBrand: '#F49C57',
  colorEmphasis: '#F49C57',
  colorPrimary: '#2C9BCE',
  colorPrimaryDark: '#477777', // TODO: replace with a set color variable
  colorDefault__old: '#8d8d8d',
  colorDefault: '#606972',
  colorHover: '#f1f8fa',
// Typography Defaults
  colorDefaultText: '#333333',
  colorDefaultheaderText: '#4d4d4d',
// Component Defaults
  darkPageheaderColor: '#606972',
  darkPageheaderLinkColor: '#868F97',
  darkPageheaderLinkhover: '#48505C',
  modalheaderColor: '#464F5B', // TODO: replace with a set color variable
  emptyStateColor: '#f1f8fa',
  bulkActionsColor: '#2C9BCE',
// Main Menu
  menuColor: '#3e4142',
  menuAccentColor: '#545758',
  menuLinkColor: '#939D9E',
  menuLinkhoverColor: '#C0CCD2',
  menuLinkActiveColor: '#ebf0f1',
  popoverTriggerColor: '#2C9BCE',
  stepProgressBarInactive: '#99BCD1',
// States
  colorError: '#ee5252',
  colorWarning: '#f7c870',
  colorSuccess: '#0fd599',
  colorDanger:  '#ee6e65',
  colorNegative:  '#ee6e65',
  colorPositive:  '#0fd599',
// Table & Row Colors and Styles
  selectedhighlight: '#EFF5F8', // TODO: replace with a set color variable
  colorActiveRow:  '#f1f8fa',
  colorActiveRowDarker: '#DFE8EB', // TODO: replace with a set color variable
// Retailer Dashboard
  retailerheroDefaultBackgroundColor: '#1ea4cc',
  retailerheroSandboxBackgroundColor: '#ffe78b',
  retailerheroVeteranBackgroundColor: '#16c5e9',
// Customer success tools
  customerSuccessheaderColor: '#721d8e',
// Menu Costing hero colors
  heroDarkBlue: '#1A384D',
  heroRed: '#994048',
  heroGreen: '#2AC1BB',
  heroOrange: '#FD996C',
  heroLightBlue: '#9CCFEC',
  heroYellow: '#FFCE6D',
  heroDarkGreen: '#0A7476',
// Hubspot colors
  hubspotGray: '#7F7F7F',
  hubspotOrange: '#F49C57',
  hubspotModalBackdrop: 'rgba(30,30,30,.6)',

  //Hubspot 2020 site
  hubspotNewPurple: '#5B61FC',
  hubspotNewGray: 'rgba(91,97,252,0.1)'
}

export default colors
